import windowutils from '../utils/window';
import analytics from '../utils/analytics';

export default class Tiles {
  constructor(el = '.tileContainer') {
    this.tileelement = el;

    this.tileelementselector =
      this.tileelement === '.tileContainer'
        ? '.tileContainer:not(.tile-hold)'
        : this.tileelement; //if tileelement is .tileContainer, use .tileContainer:not(.tile-hold) to avoid holding tiles

    // this.excludedtiles = ['plain','videoTile','news', 'twitter'];
    this.rowclass = `${this.tileelement.replace('.', '')}-row`;
    this.tilecolumnel = '.tile-column';

    this.targetspan = 12;
    this.defaultcolspan = '6';
    this.tiles = [...document.querySelectorAll(`${this.tileelementselector}`)];
    this.tilegroups = [];
    this.hasicon = false;
    this.singlelink = false;
    this.mediaquery = windowutils.currentmediaquery();
    this.parseTileLinks =
      typeof window.parseTileLinks !== 'undefined' &&
      window.parseTileLinks === false
        ? false
        : true;
    try {
      this.initialize(this.tiles);
    } catch (error) {
      console.log(error);
    }
  }

  initialize(tiles) {
    this.mapcolumns();
    window.addEventListener('resize', () => {
      windowutils.currentmediaquery() !== this.mediaquery
        ? this.mediaquerychange()
        : false;
    });
    this.preparsed = false;
    
    // Collect tiles that need to be moved
    const tilesToMove = [];
    tiles.forEach((tile, index) => {
      if (tile.parentNode.classList.contains(this.rowclass)) {
        tilesToMove.push(tile);
        this.preparsed = true;
      }
    });
    
    // Batch move all tiles at once
    if (tilesToMove.length > 0) {
      const targetRow = tilesToMove[0].parentNode;
      tilesToMove.forEach(tile => {
        targetRow.insertAdjacentElement('beforebegin', tile);
      });
    }
    
    if (this.preparsed) {
      [...document.querySelectorAll(`.${this.rowclass}`)].forEach((el) => {
        el.parentNode.removeChild(el);
      });
    }

    this.maptiles(tiles);
    this.wraptiles();
    this.mediaquerychange();
    try {
      this.trackContent();
    } catch (e) {
      console.log(e);
    }
  }

  mediaquerychange() {
    this.mediaquery = windowutils.currentmediaquery();
    this.assignclasses();
    let rows = [...document.querySelectorAll('.tileRow')];
    rows.forEach((row) => {
      row.classList.toggle('medium', this.mediaquery === 'medium');
    });
  }
  watchImage(tileimage) {
    const image = tileimage.querySelector('img');
    if (!image) return;
    if (image.complete) {
      image.classList.add('loaded');
    } else {
      image.addEventListener('load', (e) => {
        e.target.classList.add('loaded');
      });
    }
  }
  assignclasses() {
    const stripclasses = function (el) {
      if (el) {
        el.classList.remove('large-6');
        el.classList.remove('medium-4');
        el.classList.remove('medium-6');
        el.classList.remove('medium-8');
      }
    };
    this.tilegroups.forEach((tiles) => {
      const tilecount = tiles.length;
      tiles.forEach((tile, i) => {
        if (!tile.classList.contains('hide')) {
          stripclasses(tile);
          //remove tileText if empty
          let colspan = this.defaultcolspan; //default
          tile.dataset.colspan ? (colspan = tile.dataset.colspan) : false; //if tile has colspan data attribute use it
          let tileimage = tile.querySelector('.tileImage'); //get tile image
          let tiletext = tile.querySelector('.tileText')
            ? tile.querySelector('.tileText')
            : false; //get tile text
          try {
            if (tiletext && tiletext.innerHTML.trim().length == 0) {
              //if tile text is empty hide it
              tiletext.style.display = 'none';
            }
          } catch (e) {
            console.log(e);
            console.log('error at tile');
            console.log(tile);
          }
          try {
            //if tile has a tileImage and it has an image, when the image is loaded add a class to it of 'loaded'
            if (tileimage && tileimage.querySelector('img')) {
              this.watchImage(tileimage);
            }
          } catch (e) {
            console.log(e);
            console.log('error at tileimage');
            console.log(tileimage);
          }
          //if tile colspan is 3 and has tileText add a class to the tile of small-heading
          if (
            colspan === '3' &&
            tiletext &&
            tiletext.querySelector('h2, h3, h4, h5, h6')
          ) {
            tiletext.classList.add('small-heading');
          }
          if (tiletext && i !== 2 && !tiletext.classList.contains('banner')) {
            //if tile has text and is not the third tile and doesn't contain banner classlist
            if (colspan === '12' && !tile.dataset.noimage) {
              //if tile is full width and has image
              tile.classList.add('medium-12');
              tile.classList.add(`large-${colspan}`);
              if (tile.dataset.fiftyFull && tile.dataset.fiftyFull === 'true') {
                tile.classList.add('isfiftyfull');
                if (tiletext) {
                  tiletext.classList.add('large-6');
                  tiletext.classList.add('columns');
                }
                if (tileimage) {
                  tileimage.classList.add('large-6');
                  tileimage.classList.add('columns');
                }
              } else {
                if (tileimage) {
                  tileimage.classList.add('large-8');
                  tileimage.classList.add('columns');
                }
                if (tiletext && !tiletext.classList.contains('search')) {
                  tiletext.classList.add('large-4');
                  tiletext.classList.add('columns');
                }
              }
            } else {
              tile.classList.add(`large-${colspan}`, 'medium-6');
            }
          } else {
            if (colspan == 3 && tilecount != 3) {
              tile.classList.add('medium-6'); //medium 6
              tile.classList.add('is-four-column'); //add additional class for four column layout
            } else {
              tile.classList.add('medium-12');
            }
            tile.classList.add(`large-${colspan}`);
          }
        }
      });
    });
  }

  mapcolumns() {
    const tilecolumns = [...document.querySelectorAll(this.tilecolumnel)];
    if (tilecolumns) {
      tilecolumns.forEach((column) => {
        //find tiles and strip tile classes
        const tiles = [...column.querySelectorAll(this.tileelementselector)];
        tiles.forEach((tile) => {
          tile.removeAttribute('class');
          tile.classList.add('tile-column-child');
        });
        column.classList.add('tileContainer');
        column.classList.add('columns');
        column.classList.add('large-4');
      });
      this.tiles = [...document.querySelectorAll(this.tileelementselector)];
    }
  }

  maptiles(tiles) {
    let span = 0;
    let tilearray = [];
    tiles.forEach((tile) => {
      //check for .tileRow in parent and remove parent div if class exists

      if (!tile.classList.contains('hide')) {
        try {
          //find span class tile-icon
          if (tile.querySelector('.tile-icon')) {
            //use a resize observer to monitor img height
            if (this.singlelink && tile.querySelector('.tilewraplink')) {
              tile.querySelector('.tilewraplink').classList.add('has-icon');
            }
            this.hasicon = true;
            let spacer = tile.querySelector('.tile-icon-spacer');
            let img = tile.querySelector('.tile-icon');
            //add extra space for icon
            // tile.querySelector('.tileText').insertAdjacentHTML("beforeend", `<div class="tile-icon-padding"></div>`);
            //create resizeobserver
            let resizeObserver = new ResizeObserver((entries) => {
              //get element height
              let height = entries[0].contentRect.height;
              spacer.style.height = `calc(100% - ${height}px)`;
            });
            resizeObserver.observe(img);
          }
        } catch (e) {
          console.error(e);
        }
        let fullwidth = false;
        if (tile.dataset.colspan) {
          span = span + parseInt(tile.dataset.colspan);
          parseInt(tile.dataset.colspan) == 12 ? (fullwidth = true) : false;
        } else {
          span = span + parseInt(this.defaultcolspan);
        }

        if (fullwidth) {
          const tileText = tile.querySelector('.tileText');
          const tileImage = tile.querySelector('.tileImage');
          if (
            tile.querySelector('.tileImage') &&
            !tile.querySelector('.videoTile')
          ) {
            !tile.querySelector('.tileImage').querySelector('img') &&
            tile.querySelector('.tileText')
              ? tile.querySelector('.tileText').classList.add('large-12')
              : false;
            if (tile.dataset.imageRight && tile.dataset.imageRight === 'true') {
              let imageclone = tile.querySelector('.tileImage').cloneNode(true);
              imageclone.classList.add('hide-for-small-only');
              if (
                !tile.dataset.fiftyFull ||
                !tile.dataset.fiftyFull === 'true'
              ) {
                imageclone.classList.remove('large-6');
                imageclone.classList.add('large-8');
              } else {
                imageclone.classList.add('large-6');
              }
              imageclone.classList.add('columns');
              tile
                .querySelector('.tileImage')
                .classList.add('show-for-small-only');
              tile
                .querySelector('.tileText')
                .insertAdjacentElement('afterend', imageclone);
              this.watchImage(imageclone);
            }
            if (
              tileText.textContent.trim() === '' &&
              tileImage.querySelector('img')
            ) {
              tileText.remove();
              tileImage.classList.add('large-12', 'medium-12', 'small-12');
              tileImage.classList.remove('large-8', 'columns');
            }
          }
        }

        //find li with no a and add class
        try {
          if (!tile.querySelector('.link-replaced')) {
            [...tile.querySelectorAll('li')].map((el) => {
              el.querySelector('a') ? false : el.classList.add('no-link');
            });
          }
        } catch (error) {
          console.log(error);
        }
        const checkmultilinks = function (links) {
          let linkhref = '';
          let uniquelinks = true;
          if (links.length !== 0) {
            [...links].forEach((link, i) => {
              if (i === 0) {
                linkhref = link.getAttribute('href');
              }
              if (
                link.getAttribute('href') !== linkhref ||
                link.classList.contains('tile-not-expanded')
              ) {
                uniquelinks = false;
              }
            });
          }
          return uniquelinks;
        };
        const replacelinks = function (links) {
          [...links].forEach((el) => {
            let linkclass;
            el.querySelector('img')
              ? (linkclass = '')
              : (linkclass = 'link-replaced');
            if (!el.classList.contains('calltoaction')) {
              let replacementel =
                el.parentNode.tagName === 'P' &&
                !el.parentNode.classList.contains('calltoaction') &&
                !el.parentNode.classList.contains('no-bullet')
                  ? `<ul><li><span class="${linkclass}">${el.innerHTML}</span></li></ul>`
                  : `<span class="${linkclass}">${el.innerHTML}</span>`;
              el.insertAdjacentHTML('afterend', replacementel);
              el.parentNode.removeChild(el);
            }
          });
        };
        try {
          let tileElement = tile.querySelector('.tile');
          if (tileElement) {
            let classList = tileElement.classList;
            if (
              tile.querySelector('.tileText') &&
              tile.getElementsByTagName('a').length >= 1 &&
              checkmultilinks(tile.getElementsByTagName('a')) &&
              !classList.contains('plain') &&
              !classList.contains('videoTile') &&
              !classList.contains('modalTile') &&
              !classList.contains('twitter') &&
              !classList.contains('tile-07') &&
              !classList.contains('black') &&
              !classList.contains('event') &&
              this.parseTileLinks &&
              !tile.querySelector('.calltoaction') &&
              !tile.querySelector('.banner') &&
              !tile.parentNode.classList.contains('.no-bullet') &&
              !classList.contains('podcast-tile') &&
              !tile.getElementsByTagName('a')[0].classList.contains('no-tile-wrap') &&
              !tile
                .getElementsByTagName('a')[0]
                .classList.contains('twitter-timeline') //twitter embed workaround
            ) {
              if (
                tile.querySelector('.tile .tileText').childElementCount === 1 &&
                !tile.querySelector('.tile .tileImage img') &&
                !tile.querySelector('.calltoaction')
              ) {
                tile
                  .querySelector('.tile .tileText')
                  .classList.add('single-child');
              }
              let link = tile.getElementsByTagName('a')[0];
              let url = link.getAttribute('href');
              let linklabel = tile.textContent.trim();
              let ga = link.dataset.ga;
              tile
                .querySelector('.tileText')
                .setAttribute('aria-hidden', 'true');
              tile
                .querySelector('.tileImage')
                .setAttribute('aria-hidden', 'true');
              replacelinks(tile.getElementsByTagName('a'));
              let oldinner = tile.querySelector('.tile').innerHTML;
              const uofg575 = document.getElementById('uofg-575');
              if (!uofg575) {
                this.singlelink = true;
              }

              let newinner = `<a class="tilewraplink ${this.hasicon ? `has-icon` : ``}" aria-label="${linklabel}" ${ga ? `data-ga="${ga}"` : ''} href="${url}">${oldinner}</a>`;
              let el = tile.querySelector('.tile');

              let temp = document.createElement('div');
              temp.innerHTML = newinner;
              el.textContent = '';
              el.insertAdjacentHTML('beforeend', temp.innerHTML);
            }
          }
        } catch (error) {
          console.error(error);
        }

        try {
          let siblingclasslist = [];
          tile.nextElementSibling
            ? (siblingclasslist = [...tile.nextElementSibling.classList])
            : false;
          if (!tile.classList.contains('hide')) {
            if (
              span >= this.targetspan ||
              !siblingclasslist.includes(this.tileelement.replace('.', ''))
            ) {
              tilearray.push(tile);
              this.tilegroups.push(tilearray);
              tilearray = [];
              span = 0;
            } else {
              tilearray.push(tile);
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
    if (tilearray.length > 0) {
      this.tilegroups.push(tilearray);
    }
    return;
  }

  wraptiles() {
    this.tilegroups.forEach((group, i) => {
      let container = document.createElement('div');
      container.classList.add('row');
      container.classList.add('tileRow');
      container.classList.add(this.rowclass);
      container.classList.add('tilegroup-' + i);
      if (i === 0) {
        container.classList.add('first-tile-row');
      }
      group[0].parentNode.insertBefore(container, group[0]); //insert contained tiles before group
      group.forEach((el) => {
        el.querySelector('#coursefinder')
          ? container.classList.add('first-tile-row')
          : false;
        if (el.querySelector('.autocomplete-fix')) {
          container.classList.add('autocomplete-fix-next');
          container.parentNode.classList.add('autocomplete-fix');
          container.parentNode.parentNode.classList.add('autocomplete-fix');
        }
        container.appendChild(el);
      });
    });

    const tilerows = [...document.querySelectorAll('.tileRow')];
    let fixindex = false;
    tilerows.forEach((el, i) => {
      if (el.classList.contains('autocomplete-fix-next')) {
        fixindex = i + 1;
      }
    });
    fixindex ? tilerows[fixindex].classList.add('autocomplete-fix') : false;
    return;
  }

  trackContent() {
    const seek = [
      'lavendar',
      'lavender',
      'pillarbox',
      'thistle',
      'cobalt',
      'leaf',
    ];
    this.tiles.forEach((tile) => {
      const containsclasses = seek.filter((colour) => {
        return tile.querySelector('.tile').classList.contains(colour);
      });
      if (containsclasses.length > 0) {
        let largetile = false;
        [...tile.querySelectorAll('.tileText>p')].forEach((el) => {
          const wordcount = el.textContent.split(' ').filter((word) => {
            return word !== '' && word !== '\n';
          }).length;
          if (wordcount > 70) {
            largetile = true;
          }
        });
        if (largetile) {
          setTimeout(
            analytics.logevent('large tile', 'view', tile.dataset.contentid),
            1000
          );
        }
      }
      //check if tile has .tileImage class that contains an image
      // if(tile.querySelector('.tileImage') && tile.querySelector('.tileImage').querySelector('img')){
      //     setTimeout(analytics.logevent('tile image', 'view', tile.dataset.contentid), 1000);
      // }
    });
  }
}
